import React from 'react';
import styles from './ProtocolLink.module.scss';
import downloadIcon from './download_icon.svg';
import cn from 'classnames';

const ProtocolLink = ({ 
    url, 
    additionalLabel, 
    disabled,
    text,
}: IProps) => (
    <a
      target={!disabled ? "_blank" : undefined}
      rel="noopener noreferrer"
      className={cn(styles.downloadButton, disabled && styles.downloadButton_disabled)}
      href={!disabled ? url : undefined}
    >
        <img src={downloadIcon} alt="downloadIcon" />
        <span className={styles.documentUrl}>
            {text || `Скачать ${additionalLabel || 'протокол'}`}
        </span>
    </a>
);

export default ProtocolLink;

interface IProps {
    url?: string;
    additionalLabel?: string;
    disabled?: boolean;
    text?: string;
}
